import {FeatureToggleStatusEnum} from "../../../../../app-react/services/ab-testing/feature-toggle.view-model.interface";
import {IConfigInitializationParams} from "../../../config-initialization-params.interface";

export default (params: IConfigInitializationParams) => {
    const {assetsMap} = params;
    return {
        "version": "{{VERSION}}",
        "search": {
            "quickLinks": {
                "defaultValue": [
                    {
                        "text": "SLOTS_JACKPOTS",
                        "linkId": "slotsLink"
                    },
                    {
                        "text": "CASINO_GAMES",
                        "linkId": "casinoGamesLink"
                    },
                    {
                        "text": "LIVE_CASINO",
                        "linkId": "liveCasinoLink"
                    },
                    {
                        "text": "CASHIER",
                        "menuItemKey": "depositMenuItem"
                    }
                ],
                "statements": [
                    {
                        "condition": "AND",
                        "rules": [
                            {
                                "id": "isMiniOrbit",
                                "operator": "equal",
                                "value": true
                            }
                        ],
                        "value": []
                    }
                ]
            },
            "suggestedGames": {
                "defaultValue": [
                    130191,
                    2370000,
                    130012,
                    130008,
                    130043,
                    2010033
                ]
            },
            "suggestedCategories": {
                "defaultSuggestedCategories": {
                    "defaultValue": [
                        {
                            "text": "Slots & Jackpots",
                            "linkId": "slotsLink"
                        },
                        {
                            "text": "Casino Games",
                            "linkId": "casinoGamesLink"
                        },
                        {
                            "text": "Live Casino",
                            "linkId": "liveCasinoLink"
                        },
                        {
                            "text": "Cashier",
                            "menuItemKey": "depositMenuItem"
                        }
                    ],
                    "statements": [
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "isMiniOrbit",
                                    "operator": "equal",
                                    "value": true
                                }
                            ],
                            "value": []
                        }
                    ]
                },
                "suggestedCategoriesOptions": {
                    "defaultValue": [
                        {
                            "search": "slot",
                            "categories": [
                                {
                                    "text": "Slots & Jackpots",
                                    "linkId": "slotsLink"
                                },
                                {
                                    "gameID": 2010075,
                                    "text": "Dream Catcher"
                                }
                            ]
                        },
                        {
                            "search": "888",
                            "categories": [
                                {
                                    "text": "888 Exclusive Slots & Jackpots",
                                    "linkId": "slotsLink",
                                    "linkHash": "#filters=vendor_888"
                                }
                            ]
                        },
                        {
                            "search": "jackpot",
                            "categories": [
                                {
                                    "text": "Jackpot Slots",
                                    "linkId": "slotsLink",
                                    "linkHash": "#filters=jackpot"
                                },
                                {
                                    "gameID": 2010075,
                                    "text": "Dream Catcher"
                                }
                            ]
                        },
                        {
                            "search": "blackjack",
                            "categories": [
                                {
                                    "text": "Blackjack Games",
                                    "linkId": "casinoGamesLink",
                                    "linkHash": "#filters=blackjack"
                                },
                                {
                                    "gameID": 2010001,
                                    "text": "Live Blackjack"
                                }
                            ]
                        },
                        {
                            "search": "baccarat",
                            "categories": [
                                {
                                    "text": "Live Baccarat",
                                    "linkId": "liveCasinoLink",
                                    "linkHash": "#filters=all-baccarat"
                                },
                                {
                                    "text": "Baccarat Tables",
                                    "linkId": "casinoGamesLink",
                                    "linkHash": "#filters=baccarat"
                                }
                            ]
                        },
                        {
                            "search": "poker",
                            "categories": [
                                {
                                    "text": "Poker Games",
                                    "linkId": "casinoGamesLink",
                                    "linkHash": "#filters=poker"
                                },
                                {
                                    "gameID": 2010035,
                                    "text": "Live Poker Games"
                                }
                            ]
                        },
                        {
                            "search": "keno",
                            "categories": [
                                {
                                    "text": "Casino Games",
                                    "linkId": "casinoGamesLink",
                                    "linkHash": "#filters=other"
                                },
                                {
                                    "gameID": 2010075,
                                    "text": "Dream Catcher"
                                }
                            ]
                        },
                        {
                            "search": "craps",
                            "categories": [
                                {
                                    "text": "Casino Games",
                                    "linkId": "casinoGamesLink",
                                    "linkHash": "#filters=other"
                                },
                                {
                                    "gameID": 2010075,
                                    "text": "Dream Catcher"
                                }
                            ]
                        },
                        {
                            "search": "scratch card",
                            "categories": [
                                {
                                    "text": "Casino Games",
                                    "linkId": "casinoGamesLink",
                                    "linkHash": "#filters=other"
                                },
                                {
                                    "gameID": 2010075,
                                    "text": "Dream Catcher"
                                }
                            ]
                        },
                        {
                            "search": "roulette",
                            "categories": [
                                {
                                    "text": "Roulette Games",
                                    "linkId": "casinoGamesLink",
                                    "linkHash": "#filters=roulette"
                                },
                                {
                                    "gameID": 2010002,
                                    "text": "Live Roulette"
                                }
                            ]
                        },
                        {
                            "search": "live",
                            "categories": [
                                {
                                    "text": "Live Casino",
                                    "linkId": "liveCasinoLink"
                                },
                                {
                                    "gameID": 2010075,
                                    "text": "Dream Catcher"
                                }
                            ]
                        },
                        {
                            "search": "live baccarat",
                            "categories": [
                                {
                                    "text": "Live Baccarat",
                                    "linkId": "liveCasinoLink",
                                    "linkHash": "#filters=all-baccarat"
                                }
                            ]
                        }
                    ],
                    "statements": [
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "isMiniOrbit",
                                    "operator": "equal",
                                    "value": true
                                }
                            ],
                            "value": []
                        }
                    ]
                }
            },
            "videoSlidesFilterPreviewIds": ["theme_fish", "theme_greek_mythology", "freeSpins"]
        },
        "ClockAndLastLoginBox": {
            "lastLoginDisplay": {
                "defaultValue": false,
                "statements": [
                    {
                        "condition": "AND",
                        "rules": [
                            {
                                "id": "IsAuthorized",
                                "operator": "equal",
                                "value": true
                            }
                        ],
                        "value": true
                    }
                ]
            },
            "display": true
        },
        "header": {
            "gambling_message": {
                "display": false
            },
            "header_buttons": {
                "languages": {
                    "id": "app-language-switcher",
                    "display": {
                        "defaultValue": true,
                        "statements": [
                            {
                                "condition": "OR",
                                "rules": [
                                    {
                                        "id": "_IsCIS",
                                        "operator": "equal",
                                        "value": true
                                    },
                                    {
                                        "id": "_IsCIP",
                                        "operator": "equal",
                                        "value": true
                                    }
                                ],
                                "value": false
                            }
                        ]
                    }
                }
            }
        },
        "languageSwitcher": {
            "display": true
        },
        "links": {
            "promotionsCISLink": "https://www.888sport.com/online-sports-betting-promotions/#live_casino",
            "promotionsCIPLink": "https://www.888poker.com/poker-promotions/#tab-3",
            "blogLink": {
                "url": {
                    "defaultValue": "https://www.888casino.com/blog/",
                    "statements": [
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "iso3",
                                    "operator": "equal",
                                    "value": "ger"
                                }
                            ],
                            "value": "https://de.888casino.com/magazine/"
                        },
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "iso3",
                                    "operator": "equal",
                                    "value": "fin"
                                }
                            ],
                            "value": "https://fi.888casino.com/blog/"
                        }
                    ]
                }
            },
            "pokerLink": {
                "url": {
                    "defaultValue": "https://mirage-pic.888casino.com/play-poker-online/",
                    "statements": [
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "_IsUkOrIrl",
                                    "operator": "equal",
                                    "value": true
                                },
                                {
                                    "id": "operationSystem",
                                    "operator": "equal",
                                    "value": "android"
                                },
                                {
                                    "id": "isHybrid",
                                    "operator": "equal",
                                    "value": true
                                },
                            ],
                            "value": "https://888pic.onelink.me/i3ZS/casino2pokerGP"
                        },
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "_IsUkOrIrl",
                                    "operator": "equal",
                                    "value": false
                                },
                                {
                                    "id": "operationSystem",
                                    "operator": "equal",
                                    "value": "android"
                                },
                                {
                                    "id": "isHybrid",
                                    "operator": "equal",
                                    "value": true
                                },
                            ],
                            "value": "https://888pissa.onelink.me/3vpG/ib98zw5r"
                        },
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "operationSystem",
                                    "operator": "equal",
                                    "value": "ios"
                                },
                                {
                                    "id": "isHybrid",
                                    "operator": "equal",
                                    "value": true
                                },
                            ],
                            "value": "https://888pic.onelink.me/i3ZS/casino2poker"
                        },
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "env",
                                    "operator": "equal",
                                    "value": "prod"
                                }
                            ],
                            "value": "https://www.888poker.com/"
                        }
                    ]
                },
                "urlBuilderStrategy": {
                    "defaultValue": undefined,
                    "statements": [
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "isHybrid",
                                    "operator": "equal",
                                    "value": true
                                }
                            ],
                            "value": "useUrl"
                        }
                    ]
                }
            },
            "sportLink": {
                "url": "https://www.888sport.com"
            },
            "888SiteLink": "https://www.888.com",
            "responsibleGamingLink": {
                "url": "/security-and-privacy/responsible-gaming/"
            }
        },
        "menuItems": {
            "loyaltyIndicatorMenuItem": {
                "display": {
                    "defaultValue": false,
                    "statements": [
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "IsAuthorized",
                                    "operator": "equal",
                                    "value": true
                                },
                                {
                                    "id": "deviceType",
                                    "operator": "equal",
                                    "value": "pc"
                                },
                                {
                                    "id": "_IsCIP",
                                    "operator": "equal",
                                    "value": true
                                }
                            ],
                            "value": true
                        }
                    ]
                }
            },
            "myClubMenuItem": {
                "display": {
                    "defaultValue": false,
                    "statements": [
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "IsAuthorized",
                                    "operator": "equal",
                                    "value": true
                                },
                                {
                                    "id": "deviceType",
                                    "operator": "equal",
                                    "value": "pc"
                                },
                                {
                                    "id": "_IsCIP",
                                    "operator": "equal",
                                    "value": true
                                }
                            ],
                            "value": true
                        }
                    ]
                }
            },
            "vipClubMenuItem": {
                "display": {
                    "defaultValue": true,
                    "statements": [
                        {
                            "condition": "OR",
                            "rules": [
                                {
                                    "id": "IsAuthorized",
                                    "operator": "equal",
                                    "value": true
                                },
                                {
                                    "id": "isHybrid",
                                    "operator": "equal",
                                    "value": true
                                },
                                {
                                    "id": "_IsCIS",
                                    "operator": "equal",
                                    "value": true
                                },
                                {
                                    "id": "_IsCIP",
                                    "operator": "equal",
                                    "value": true
                                },
                                {
                                    "id": "RegistrationCountry",
                                    "operator": "equal",
                                    "value": "gbr"
                                },
                                {
                                    "id": "countryCode",
                                    "operator": "equal",
                                    "value": "gbr"
                                }
                            ],
                            "value": false
                        }
                    ]
                }
            },
            "pokerCrossBrandMenuItem": {
                "menuItemIcon": "sideMenuPokerChip",
                "display": {
                    "defaultValue": false,
                    "statements": [
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "deviceType",
                                    "operator": "equal",
                                    "value": "mobile"
                                },
                                {
                                    "id": "_IsCIS",
                                    "operator": "is_falsy",
                                    "value": true
                                }
                            ],
                            "value": true
                        }
                    ]
                }
            },
            "sportCrossBrandMenuItem": {
                "menuItemIcon": "sideMenuSportFootball",
                "display": {
                    "defaultValue": false,
                    "statements": [
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "deviceType",
                                    "operator": "equal",
                                    "value": "mobile"
                                },
                                {
                                    "id": "_IsCIP",
                                    "operator": "is_falsy",
                                    "value": true
                                }
                            ],
                            "value": true
                        }
                    ]
                }
            },
            "blogMenuItem": {
                "display": {
                    "defaultValue": true,
                    "statements": [
                        {
                            "condition": "OR",
                            "rules": [
                                {
                                    "id": "IsAuthorized",
                                    "operator": "equal",
                                    "value": true
                                },
                                {
                                    "id": "isHybrid",
                                    "operator": "equal",
                                    "value": true
                                },
                                {
                                    "id": "_IsCIS",
                                    "operator": "equal",
                                    "value": true
                                }
                            ],
                            "value": false
                        }
                    ]
                }
            },
            "gameCareMenuItem": {
                "display": {
                    "defaultValue": false,
                    "statements": [
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "deviceType",
                                    "operator": "equal",
                                    "value": "mobile"
                                },
                                {
                                    "id": "regulationID",
                                    "operator": "equal",
                                    "value": 255
                                },
                                {
                                    "id": "isMiniOrbit",
                                    "operator": "equal",
                                    "value": false
                                }
                            ],
                            "value": true
                        }
                    ]
                }
            },
            "beGambleAwareMenuItem": {
                "display": {
                    "defaultValue": false,
                    "statements": [
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "deviceType",
                                    "operator": "equal",
                                    "value": "mobile"
                                },
                                {
                                    "id": "regulationID",
                                    "operator": "equal",
                                    "value": 255
                                },
                                {
                                    "id": "isMiniOrbit",
                                    "operator": "equal",
                                    "value": false
                                }
                            ],
                            "value": true
                        }
                    ]
                }
            },
            "timeSpentReminderMenuItem": {
                "display": {
                    "defaultValue": false,
                    "statements": [
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "regulationID",
                                    "operator": "any_of",
                                    "value": [255, 16]
                                },
                                {
                                    "id": "isMiniOrbit",
                                    "operator": "equal",
                                    "value": false
                                }
                            ],
                            "value": true
                        }
                    ]
                }
            }
        },
        "sideMenu": {
            "crossBrandAboveSearch": [
                "sportCrossBrandMenuItem",
                "pokerCrossBrandMenuItem"
            ],
            "menuLinksBlockOrder": {
                "defaultValue": [
                    [
                        "depositMenuItem"
                    ],
                    [
                        "promotionsMenuItem",
                        "loyaltyIndicatorMenuItem",
                        "myClubMenuItem"
                    ],
                    [
                        "homeMenuItem",
                        "slotsMenuItem",
                        "liveCasinoMenuItem",
                        "newGamesMenuItem",
                        "casinoMenuItem",
                        "jackpotsMenuItem",
                        "exclusive888arenaMenuItem"
                    ],
                    [
                        "installPWAMenuItem",
                        "vipClubMenuItem",
                        "blogMenuItem"
                    ],
                    [
                        "chatMenuItem"
                    ]
                ],
                "statements": [
                    {
                        "condition": "AND",
                        "rules": [
                            {
                                "id": "statusGroupId",
                                "operator": "any_of",
                                "value": [
                                    1,
                                    2,
                                    3,
                                    5
                                ]
                            },
                            {
                                "id": "IsAuthorized",
                                "operator": "equal",
                                "value": false
                            }
                        ],
                        "value": [
                            [
                                "depositMenuItem"
                            ],
                            [
                                "promotionsMenuItem",
                                "installPWAMenuItem",
                                "vipClubMenuItem"
                            ],
                            [
                                "loyaltyIndicatorMenuItem",
                                "myClubMenuItem"
                            ],
                            [
                                "homeMenuItem",
                                "slotsMenuItem",
                                "liveCasinoMenuItem",
                                "newGamesMenuItem",
                                "casinoMenuItem",
                                "jackpotsMenuItem",
                                "exclusive888arenaMenuItem"
                            ],
                            [
                                "blogMenuItem"
                            ]
                        ]
                    },
                    {
                        "condition": "AND",
                        "rules": [
                            {
                                "id": "statusGroupId",
                                "operator": "any_of",
                                "value": [
                                    1,
                                    2,
                                    3,
                                    5
                                ]
                            },
                            {
                                "id": "IsAuthorized",
                                "operator": "equal",
                                "value": true
                            }
                        ],
                        "value": [
                            [
                                "depositMenuItem"
                            ],
                            [
                                "promotionsMenuItem",
                                "chatMenuItem"
                            ],
                            [
                                "loyaltyIndicatorMenuItem",
                                "myClubMenuItem"
                            ],
                            [
                                "homeMenuItem",
                                "slotsMenuItem",
                                "liveCasinoMenuItem",
                                "newGamesMenuItem",
                                "casinoMenuItem",
                                "jackpotsMenuItem",
                                "exclusive888arenaMenuItem"
                            ],
                            [
                                "installPWAMenuItem"
                            ],
                            [
                                "blogMenuItem"
                            ]
                        ]
                    },
                    {
                        "condition": "AND",
                        "rules": [
                            {
                                "id": "IsAuthorized",
                                "operator": "equal",
                                "value": true
                            }
                        ],
                        "value": [
                            [
                                "depositMenuItem"
                            ],
                            [
                                "promotionsMenuItem",
                                "loyaltyIndicatorMenuItem",
                                "myClubMenuItem"
                            ],
                            [
                                "homeMenuItem",
                                "slotsMenuItem",
                                "liveCasinoMenuItem",
                                "newGamesMenuItem",
                                "casinoMenuItem",
                                "jackpotsMenuItem",
                                "exclusive888arenaMenuItem"
                            ],
                            [
                                "installPWAMenuItem"
                            ],
                            [
                                "vipClubMenuItem",
                                "blogMenuItem"
                            ],
                            [
                                "chatMenuItem"
                            ]
                        ]
                    }
                ]
            },
            "store_button": {
                "display": {
                    "defaultValue": false,
                    "statements": [
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "deviceType",
                                    "operator": "equal",
                                    "value": "mobile"
                                },
                                {
                                    "id": "operationSystem",
                                    "operator": "equal",
                                    "value": "ios"
                                },
                                {
                                    "id": "isHybrid",
                                    "operator": "equal",
                                    "value": false
                                },
                                {
                                    "condition": "OR",
                                    "rules": [
                                        {
                                            "id": "countryCode",
                                            "operator": "equal",
                                            "value": "dan"
                                        }
                                    ]
                                }
                            ],
                            "value": true
                        },
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "deviceType",
                                    "operator": "equal",
                                    "value": "mobile"
                                },
                                {
                                    "id": "operationSystem",
                                    "operator": "equal",
                                    "value": "android"
                                },
                                {
                                    "id": "isHybrid",
                                    "operator": "equal",
                                    "value": false
                                },
                                {
                                    "condition": "OR",
                                    "rules": [
                                        {
                                            "id": "countryCode",
                                            "operator": "equal",
                                            "value": "gbr"
                                        }
                                    ]
                                }
                            ],
                            "value": false
                        }
                    ]
                },
                "appLink": {
                    "defaultValue": "",
                    "statements": [
                        {
                            "rules": [
                                {
                                    "id": "operationSystem",
                                    "operator": "equal",
                                    "value": "ios"
                                }
                            ],
                            "value": "https://app.appsflyer.com/id998457567"
                        },
                        {
                            "rules": [
                                {
                                    "id": "operationSystem",
                                    "operator": "equal",
                                    "value": "android"
                                }
                            ],
                            "value": "https://play.google.com/store/apps/details?id=com.r888.rl"
                        }
                    ]
                }
            },
            "helpLinkMobile": {
                "display": true
            }
        },
        "bottomNavigationBar": {
            "menuItemsOverride": {
                "sportCrossBrandMenuItem": {
                    "display": true
                },
                "videoSlideExploreMenuItem": {
                    "display": {
                        "defaultValue": false,
                        "statements": [
                            {
                                "condition": "AND",
                                "rules": [
                                    {
                                        "id": "videoSlidesEnabled",
                                        "operator": "equal",
                                        "value": true
                                    }
                                ],
                                "value": true
                            }
                        ]
                    }
                },
                "slotsMenuItem": {
                    "display": {
                        "defaultValue": true,
                        "statements": [
                            {
                                "condition": "AND",
                                "rules": [
                                    {
                                        "id": "videoSlidesEnabled",
                                        "operator": "equal",
                                        "value": true
                                    }
                                ],
                                "value": false
                            }
                        ]
                    }
                },
            },
            "menuItemsOrder": [
                "homeMenuItem",
                "slotsMenuItem",
                "liveCasinoMenuItem",
                "videoSlideExploreMenuItem",
                "promotionsMenuItem",
                "sportCrossBrandMenuItem"
            ]
        },
        "drawer": {
            "welcomeMessage": {
                "conditions": [
                    {
                        "time": "00:00",
                        "text": "GREETING_MORNING"
                    },
                    {
                        "time": "12:00",
                        "text": "GREETING_AFTERNOON"
                    },
                    {
                        "time": "18:00",
                        "text": "GREETING_EVENING"
                    },
                    {
                        "time": "22:00",
                        "text": "GREETING_NIGHT"
                    }
                ],
                "defaultMessage": "GREETING_DEFAULT",
                "showUserTitle": false,
                "showFirstName": true,
                "showLastName": false
            },

            "menuItemsOverride": {
                "myClubMenuItem": {
                    "display": {
                        "defaultValue": false,
                        "statements": [
                            {
                                "condition": "AND",
                                "rules": [
                                    {
                                        "id": "_IsCIP",
                                        "operator": "equal",
                                        "value": true
                                    }
                                ],
                                "value": true
                            }
                        ]
                    }
                }
            },

            "usefulLinks":
                {
                    "defaultValue": [
                        [
                            {
                                "menuItemKey": "historyMenuItem",
                                "subItems": [
                                    "gamingHistoryMenuItem",
                                    "transactionHistoryMenuItem",
                                ]
                            },
                            "compPointsMenuItem",
                            "timeSpentReminderMenuItem",
                            "touchIdMenuItem",
                            "aboutDialogMenuItem",
                            "gameCareMenuItem",
                            "beGambleAwareMenuItem",
                            "controlCenterMenuItem",
                            "hybridInfoMenuItem"
                        ], [
                            "helpCenterMenuItem",
                        ]
                    ],
                    "statements": [
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "_IsUk",
                                    "operator": "equal",
                                    "value": "true"
                                },
                                {
                                    "id": "_IsCIP",
                                    "operator": "equal",
                                    "value": "false"
                                },
                                {
                                    "id": "_IsCIS",
                                    "operator": "equal",
                                    "value": "false"
                                }
                            ],
                            "value": [
                                [
                                    {
                                        "menuItemKey": "historyMenuItem",
                                        "subItems": [
                                            "gamingHistoryMenuItem",
                                            "transactionHistoryMenuItem",
                                        ]
                                    },
                                    "cashierUploadDocumentsMenuItem",
                                    "compPointsMenuItem",
                                    "timeSpentReminderMenuItem",
                                    "touchIdMenuItem",
                                    "aboutDialogMenuItem",
                                    "gameCareMenuItem",
                                    "beGambleAwareMenuItem",
                                    "controlCenterMenuItem",
                                    "hybridInfoMenuItem"
                                ], [
                                    "helpCenterMenuItem",
                                ]
                            ]
                        }
                    ]
                },
            "userMenuItems": [
                "myClubMenuItem"
            ],
            "showLoyalty": {
                "display": {
                    "defaultValue": false,
                    "statements": [
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "IsAuthorized",
                                    "operator": "equal",
                                    "value": true
                                },
                                {
                                    "id": "deviceType",
                                    "operator": "equal",
                                    "value": "mobile"
                                },
                                {
                                    "id": "_IsCIP",
                                    "operator": "equal",
                                    "value": true
                                }
                            ],
                            "value": true
                        }
                    ]
                }
            },
            "saveGamesWidget": {
                "display": true
            }
        },
        "footer": {
            "componentID": {
                "defaultValue": "393808",
                "statements": [
                    {
                        "condition": "AND",
                        "rules": [
                            {
                                "id": "isEmbeddedHybrid",
                                "operator": "equal",
                                "value": true
                            }
                        ],
                        "value": "455600"
                    }
                ]
            },
            "templateID": {
                "defaultValue": "392012"
            }
        },
        "arenas": {
            "videoSlidesArena": {
                "header": {
                    "licenseStatus": {
                        "text": "UK_LICENSE_STATUS",
                        "display": {
                            "defaultValue": false,
                            "statements": [
                                {
                                    "condition": "AND",
                                    "rules": [
                                        {
                                            "id": "regulationID",
                                            "operator": "equal",
                                            "value": 255
                                        }
                                    ],
                                    "value": true
                                }
                            ]
                        }
                    }
                },
                "promotionalBanners": [
                    {
                        "componentID": "630507",
                        "templateID": "392012",
                    }
                ],
                "filters": [
                    {
                        "translationKey": "Seasonal",
                        "category": "themes",
                        "id": "theme_seasonal",
                    },
                    {
                        "translationKey": "FREE_SPINS",
                        "category": "features",
                        "id": "freeSpins",
                    },
                    {
                        "translationKey": "Fish",
                        "category": "themes",
                        "id": "theme_fish",
                    },
                    {
                        "translationKey": "JACKPOT",
                        "category": "hasJackpot",
                        "id": "has-jackpot",
                    },
                    {
                        "translationKey": "888 Exclusive",
                        "category": "vendor",
                        "id": "vendor_888",
                    },
                    {
                        "translationKey": "Pragmatic",
                        "category": "vendors",
                        "id": "vendor_pragmatic",
                    },
                    {
                        "translationKey": "Games Global",
                        "category": "vendors",
                        "id": "vendor_gamesglobal",
                    },
                    {
                        "translationKey": "Blueprint",
                        "category": "vendors",
                        "id": "vendor_blueprint",
                    },
                    {
                        "translationKey": "Greek Mythology",
                        "category": "themes",
                        "id": "theme_greek_mythology",
                    }
                ]
            },
            "slots": {
                "topImage": {
                    "defaultValue": assetsMap.images.banners.slots_arena_banner_pc_png.toString(),
                    "statements": [
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "mAndBelow",
                                    "operator": "equal",
                                    "value": true
                                }
                            ],
                            "value": assetsMap.images.banners.slots_arena_banner_mobile_png.toString()
                        }
                    ]
                },
                "animatedTopImage": {
                    "url": {
                        "defaultValue": assetsMap.images.animated_banners.slots_arena_banner_pc_lottie.toString(),
                        "statements": [
                            {
                                "condition": "AND",
                                "rules": [
                                    {
                                        "id": "mAndBelow",
                                        "operator": "equal",
                                        "value": true
                                    }
                                ],
                                "value": assetsMap.images.animated_banners.slots_arena_banner_mobile_lottie.toString()
                            }
                        ]
                    }
                },
                "title": {
                    "defaultValue": "INFO_TITLE_ARENA_SLOTS",
                    "statements": []
                },
                "filters": {
                    "defaultValue": [
                        "vendor_888",
                        "vendor_pragmatic",
                        "vendor_playngo",
                        "vendor_netent",
                        "vendor_playtech",
                        "vendor_redtiger",
                        "twenty-five-plus"
                    ],
                    "statements": [
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "isMobile",
                                    "operator": "equal",
                                    "value": true
                                }
                            ],
                            "value": [
                                "vendor_888",
                                "vendor_playtech",
                                "vendor_netent",
                                "vendor_redtiger",
                                "vendor_playngo",
                                "vendor_pragmatic",
                                "vendor_blueprint",
                                "one-to-twenty-five",
                                "twenty-five-plus"
                            ]
                        }
                    ]
                },
                "infoSideBar": {
                    "infoImage": assetsMap.images.arenas.HomePage.slots_arena_info_png.toString(),
                    "infoTitle": "INFO_TITLE_ARENA_SLOTS",
                    "infoText": "INFO_TEXT_ARENA_SLOTS"
                },
                "promotionalBanner": {
                    "componentID": "447897",
                    "templateID": "392012"
                },
                "linkToOffer": {
                    "welcomeBonus": {
                        "componentID": "482091",
                        "templateID": "392012",
                        "display": {
                            "defaultValue": true,
                            "statements": [
                                {
                                    "rules": [
                                        {
                                            "id": "_IsCstatus",
                                            "operator": "equal",
                                            "value": true
                                        }
                                    ],
                                    "value": false
                                }
                            ]
                        }
                    }
                },
                "seoSection": {
                    "display": {
                        "defaultValue": true,
                        "statements": [
                            {
                                "condition": "OR",
                                "rules": [
                                    {
                                        "id": "isEmbeddedHybrid",
                                        "operator": "equal",
                                        "value": true
                                    },
                                    {
                                        "id": "IsAuthorized",
                                        "operator": "equal",
                                        "value": true
                                    }
                                ],
                                "value": false
                            }
                        ]
                    },
                    "componentID": {
                        "defaultValue": "392019"
                    },
                    "templateID": {
                        "defaultValue": "392012"
                    }
                }
            },
            "exclusive888Games": {
                "topImage": {
                    "defaultValue": assetsMap.images.banners._888exclusive_arena_banner_pc_png.toString(),
                    "statements": [
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "mAndBelow",
                                    "operator": "equal",
                                    "value": true
                                }
                            ],
                            "value": assetsMap.images.banners._888exclusive_arena_banner_mobile_png.toString()
                        }
                    ]
                },
                "animatedTopImage": {
                    "url": {
                        "defaultValue": assetsMap.images.animated_banners.exclusive_arena_banner_pc_lottie.toString(),
                        "statements": [
                            {
                                "condition": "AND",
                                "rules": [
                                    {
                                        "id": "mAndBelow",
                                        "operator": "equal",
                                        "value": true
                                    }
                                ],
                                "value": assetsMap.images.animated_banners.exclusive_arena_banner_mobile_lottie.toString()
                            }
                        ]
                    }
                },
                "title": "EXCLUSIVE",
                "filters": [
                    "slots",
                    "blackjack",
                    "roulette",
                    "other"
                ],
                "infoSideBar": {
                    "infoImage": assetsMap.images.arenas.HomePage._888exclusive_arena_info_png.toString(),
                    "infoTitle": "INFO_TITLE_ARENA_888_EXCLUSIVE_GAMES",
                    "infoText": "INFO_TEXT_ARENA_888_EXCLUSIVE_GAMES"
                },
                "promotionalBanner": {
                    "componentID": "473559",
                    "templateID": "392012"
                },
                "linkToOffer": {
                    "welcomeBonus": {
                        "componentID": "482097",
                        "templateID": "392012",
                        "display": {
                            "defaultValue": true,
                            "statements": [
                                {
                                    "rules": [
                                        {
                                            "id": "_IsCstatus",
                                            "operator": "equal",
                                            "value": true
                                        }
                                    ],
                                    "value": false
                                }
                            ]
                        }
                    }
                },
                "seoSection": {
                    "display": {
                        "defaultValue": true,
                        "statements": [
                            {
                                "condition": "OR",
                                "rules": [
                                    {
                                        "id": "isEmbeddedHybrid",
                                        "operator": "equal",
                                        "value": true
                                    },
                                    {
                                        "id": "IsAuthorized",
                                        "operator": "equal",
                                        "value": true
                                    }
                                ],
                                "value": false
                            }
                        ]
                    },
                    "componentID": "473549",
                    "templateID": "392012"
                }
            },
            "jackpots": {
                "topImage": {
                    "defaultValue":  assetsMap.images.banners.jackpot_arena_banner_pc_png.toString(),
                    "statements": [
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "mAndBelow",
                                    "operator": "equal",
                                    "value": true
                                }
                            ],
                            "value": assetsMap.images.banners.jackpot_arena_banner_mobile_png.toString()
                        }
                    ]
                },
                "animatedTopImage": {
                    "url": {
                        "defaultValue": assetsMap.images.animated_banners.jackpot_arena_banner_pc_lottie.toString(),
                        "statements": [
                            {
                                "condition": "AND",
                                "rules": [
                                    {
                                        "id": "mAndBelow",
                                        "operator": "equal",
                                        "value": true
                                    }
                                ],
                                "value": assetsMap.images.animated_banners.jackpot_arena_banner_mobile_lottie.toString()
                            }
                        ]
                    }
                },
                "title": {
                    "defaultValue": "INFO_TITLE_ARENA_JACKPOTS",
                    "statements": []
                },
                "filters": [],
                "infoSideBar": {
                    "infoImage": assetsMap.images.arenas.HomePage.slots_arena_info_png.toString(),
                    "infoTitle": "INFO_TITLE_ARENA_SLOTS",
                    "infoText": "INFO_TEXT_ARENA_SLOTS"
                },
                "promotionalBanner": {
                    "componentID": "462351",
                    "templateID": "392012"
                },
                "linkToOffer": {
                    "welcomeBonus": {
                        "componentID": "482079",
                        "templateID": "392012",
                        "display": {
                            "defaultValue": true,
                            "statements": [
                                {
                                    "rules": [
                                        {
                                            "id": "_IsCstatus",
                                            "operator": "equal",
                                            "value": true
                                        }
                                    ],
                                    "value": false
                                }
                            ]
                        }
                    }
                },
                "seoSection": {
                    "display": {
                        "defaultValue": true,
                        "statements": [
                            {
                                "condition": "AND",
                                "rules": [
                                    {
                                        "id": "IsAuthorized",
                                        "operator": "equal",
                                        "value": true
                                    }
                                ],
                                "value": false
                            }
                        ]
                    },
                    "componentID": {
                        "defaultValue": "461357"
                    },
                    "templateID": {
                        "defaultValue": "392012"
                    }
                }
            },
            "instantWinGames": {
                "title": "INSTANT_WIN_GAMES_ARENA",
                "topImage": {
                    "defaultValue": assetsMap.images.banners.InstantWin_arena_banner_pc_png.toString(),
                    "statements": [
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "mAndBelow",
                                    "operator": "equal",
                                    "value": true
                                }
                            ],
                            "value": assetsMap.images.banners.InstantWin_arena_banner_mobile_png.toString()
                        }
                    ]
                },
                "filters": [
                    "scratchCards",
                    "keno",
                    "other"
                ],
                "infoSideBar": {
                    "infoImage": assetsMap.images.arenas.HomePage.InstantWin_game_info_png.toString(),
                    "infoTitle": "INFO_TITLE_ARENA_INSTANT_WIN_GAMES",
                    "infoText": "INFO_TEXT_ARENA_INSTANT_WIN_GAMES"
                },
                "promotionalBanner": {
                    "display": false,
                    "componentID": "464677",
                    "templateID": "392012"
                },
                "linkToOffer": {
                    "welcomeBonus": {
                        "componentID": "482076",
                        "templateID": "392012",
                        "display": {
                            "defaultValue": true,
                            "statements": [
                                {
                                    "rules": [
                                        {
                                            "id": "_IsCstatus",
                                            "operator": "equal",
                                            "value": true
                                        }
                                    ],
                                    "value": false
                                }
                            ]
                        }
                    }
                },
                "seoSection": {
                    "display": {
                        "defaultValue": true,
                        "statements": [
                            {
                                "condition": "OR",
                                "rules": [
                                    {
                                        "id": "isEmbeddedHybrid",
                                        "operator": "equal",
                                        "value": true
                                    },
                                    {
                                        "id": "IsAuthorized",
                                        "operator": "equal",
                                        "value": true
                                    }
                                ],
                                "value": false
                            }
                        ]
                    },
                    "componentID": "464673",
                    "templateID": "392012"
                }
            },
            "casinoGames": {
                "topImage": {
                    "defaultValue": assetsMap.images.banners.cards_arena_banner_pc_png.toString(),
                    "statements": [
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "mAndBelow",
                                    "operator": "equal",
                                    "value": true
                                }
                            ],
                            "value": assetsMap.images.banners.cards_arena_banner_mobile_png.toString()
                        }
                    ]
                },
                "animatedTopImage": {
                    "url": {
                        "defaultValue": assetsMap.images.animated_banners.casinogames_arena_banner_pc_lottie.toString(),
                        "statements": [
                            {
                                "condition": "AND",
                                "rules": [
                                    {
                                        "id": "mAndBelow",
                                        "operator": "equal",
                                        "value": true
                                    }
                                ],
                                "value": assetsMap.images.animated_banners.casinogames_arena_banner_mobile_lottie.toString()
                            }
                        ]
                    }
                },
                "title": {
                    "defaultValue": "INFO_TITLE_ARENA_CASINO",
                    "statements": []
                },
                "filters": [
                    "roulette",
                    "blackjack",
                    "baccarat",
                    "poker",
                    "other"
                ],
                "infoSideBar": {
                    "infoImage": assetsMap.images.arenas.HomePage.cards_arena_info_png.toString(),
                    "infoTitle": "INFO_TITLE_ARENA_CASINO",
                    "infoText": "INFO_TEXT_ARENA_CASINO"
                },
                "promotionalBanner": {
                    "componentID": "447898",
                    "templateID": "392012"
                },
                "linkToOffer": {
                    "welcomeBonus": {
                        "componentID": "482073",
                        "templateID": "392012",
                        "display": {
                            "defaultValue": true,
                            "statements": [
                                {
                                    "rules": [
                                        {
                                            "id": "_IsCstatus",
                                            "operator": "equal",
                                            "value": true
                                        }
                                    ],
                                    "value": false
                                }
                            ]
                        }
                    }
                },
                "seoSection": {
                    "display": {
                        "defaultValue": true,
                        "statements": [
                            {
                                "condition": "OR",
                                "rules": [
                                    {
                                        "id": "isEmbeddedHybrid",
                                        "operator": "equal",
                                        "value": true
                                    },
                                    {
                                        "id": "IsAuthorized",
                                        "operator": "equal",
                                        "value": true
                                    }
                                ],
                                "value": false
                            }
                        ]
                    },
                    "componentID": {
                        "defaultValue": "392027"
                    },
                    "templateID": {
                        "defaultValue": "392012"
                    }
                }
            },
            "newLiveCasino": {
                "topImage": {
                    "defaultValue": assetsMap.images.banners.evo_lobby_banner_pc_png.toString(),
                    "statements": [
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "mAndBelow",
                                    "operator": "equal",
                                    "value": true
                                }
                            ],
                            "value": assetsMap.images.banners.evo_lobby_banner_mobile_png.toString()
                        }
                    ]
                },
                "animatedTopImage": {
                    "url": {
                        "defaultValue": assetsMap.images.animated_banners.livecasino_arena_banner_pc_lottie.toString(),
                        "statements": [
                            {
                                "condition": "AND",
                                "rules": [
                                    {
                                        "id": "mAndBelow",
                                        "operator": "equal",
                                        "value": true
                                    }
                                ],
                                "value": assetsMap.images.animated_banners.livecasino_arena_banner_mobile_lottie.toString()
                            }
                        ]
                    }
                },
                "title": "LIVE_CASINO",
                "useAISortedList": false,
                "arenas": {
                    "defaultValue": [
                        {
                            "title": {
                                "defaultValue": "TOP_EVO_GAMES"
                            },
                            "image": assetsMap.images.arenas.LiveArenas.live_arena_roulette_png.toString(),
                            "display": true,
                            "seoPage": "/live-casino/elite-lounge/",
                            "filter": "top-games",
                            "maxGamesToShow": 24
                        },
                        {
                            "title": "EXCLUSIVE",
                            "image": assetsMap.images.arenas.LiveArenas.live_arena_elite_lounge_png.toString(),
                            "display": true,
                            "seoPage": "/live-casino/elite-lounge/",
                            "filter": "live-elite-lounge-or-exclusive",
                            "banners": {
                                "promotionalBanner": {
                                    "templateID": "392012",
                                    "componentID": "517070"
                                }
                            }
                        },
                        {
                            "title": "NEW_GAMES",
                            "image": assetsMap.images.arenas.LiveArenas.live_arena_roulette_png.toString(),
                            "display": true,
                            "seoPage": "/live-casino/elite-lounge/",
                            "filter": "new",
                            "banners": {
                                "promotionalBanner": {
                                    "templateID": "392012",
                                    "componentID": "517063"
                                }
                            }
                        },
                        {
                            "title": "ROULETTE",
                            "image": assetsMap.images.arenas.LiveArenas.live_arena_roulette_png.toString(),
                            "display": true,
                            "seoPage": "/live-casino/roulette/",
                            "filter": "live-roulette",
                            "banners": {
                                "promotionalBanner": {
                                    "templateID": "392012",
                                    "componentID": "517065"
                                }
                            }
                        },
                        {
                            "title": "BLACKJACK",
                            "image": assetsMap.images.arenas.LiveArenas.live_arena_bj_png.toString(),
                            "display": true,
                            "seoPage": "/live-casino/blackjack/",
                            "filter": "live-blackjack",
                            "banners": {
                                "promotionalBanner": {
                                    "templateID": "392012",
                                    "componentID": "517068"
                                }
                            }
                        },
                        {
                            "title": "POKER_GAMES",
                            "image": assetsMap.images.arenas.LiveArenas.live_arena_bj_png.toString(),
                            "display": true,
                            "seoPage": "/live-casino/casino-holdem/",
                            "filter": "live-poker",
                            "banners": {
                                "promotionalBanner": {
                                    "templateID": "392012",
                                    "componentID": "517073"
                                }
                            }
                        },
                        {
                            "title": "BACCARAT",
                            "image": assetsMap.images.arenas.LiveArenas.live_arena_baccarat_png.toString(),
                            "display": true,
                            "seoPage": "/live-casino/baccarat/",
                            "filter": "live-baccarat",
                            "banners": {
                                "promotionalBanner": {
                                    "templateID": "392012",
                                    "componentID": "517077"
                                }
                            }
                        },
                        {
                            "title": "GAME_SHOWS",
                            "image": assetsMap.images.arenas.LiveArenas.live_arena_dream_catcher_png.toString(),
                            "display": true,
                            "seoPage": "/live-casino/dream-catcher/",
                            "filter": "live-game-shows",
                            "banners": {
                                "promotionalBanner": {
                                    "templateID": "392012",
                                    "componentID": "517084"
                                }
                            }
                        },
                        {
                            "title": "SPEED_GAMES",
                            "image": assetsMap.images.arenas.LiveArenas.live_arena_dream_catcher_png.toString(),
                            "display": true,
                            "seoPage": "/live-casino/speed-games/",
                            "filter": "live-speed-games",
                            "banners": {
                                "promotionalBanner": {
                                    "templateID": "392012",
                                    "componentID": "517084"
                                }
                            }
                        }
                    ],
                    "statements": [
                        {
                            "condition": "OR",
                            "rules": [
                                {
                                    "id": "_IsHvOrVip",
                                    "operator": "equal",
                                    "value": true
                                }
                            ],
                            "value": [
                                {
                                    "title": {
                                        "defaultValue": "TOP_EVO_GAMES"
                                    },
                                    "image": assetsMap.images.arenas.LiveArenas.live_arena_roulette_png.toString(),
                                    "display": true,
                                    "seoPage": "/live-casino/elite-lounge/",
                                    "maxGamesToShow": 24
                                },
                                {
                                    "title": "EXCLUSIVE",
                                    "image": assetsMap.images.arenas.LiveArenas.live_arena_elite_lounge_png.toString(),
                                    "display": true,
                                    "seoPage": "/live-casino/elite-lounge/",
                                    "filter": "live-elite-lounge-or-exclusive",
                                    "banners": {
                                        "promotionalBanner": {
                                            "templateID": "392012",
                                            "componentID": "517070"
                                        }
                                    }
                                },
                                {
                                    "title": "NEW_GAMES",
                                    "image": assetsMap.images.arenas.LiveArenas.live_arena_roulette_png.toString(),
                                    "display": true,
                                    "seoPage": "/live-casino/elite-lounge/",
                                    "filter": "new",
                                    "banners": {
                                        "promotionalBanner": {
                                            "templateID": "392012",
                                            "componentID": "517063"
                                        }
                                    }
                                },
                                {
                                    "title": "ROULETTE",
                                    "image": assetsMap.images.arenas.LiveArenas.live_arena_roulette_png.toString(),
                                    "display": true,
                                    "seoPage": "/live-casino/roulette/",
                                    "filter": "live-roulette",
                                    "banners": {
                                        "promotionalBanner": {
                                            "templateID": "392012",
                                            "componentID": "517065"
                                        }
                                    }
                                },
                                {
                                    "title": "BLACKJACK",
                                    "image": assetsMap.images.arenas.LiveArenas.live_arena_bj_png.toString(),
                                    "display": true,
                                    "seoPage": "/live-casino/blackjack/",
                                    "filter": "live-blackjack",
                                    "banners": {
                                        "promotionalBanner": {
                                            "templateID": "392012",
                                            "componentID": "517068"
                                        }
                                    }
                                },
                                {
                                    "title": "POKER_GAMES",
                                    "image": assetsMap.images.arenas.LiveArenas.live_arena_bj_png.toString(),
                                    "display": true,
                                    "seoPage": "/live-casino/casino-holdem/",
                                    "filter": "live-poker",
                                    "banners": {
                                        "promotionalBanner": {
                                            "templateID": "392012",
                                            "componentID": "517073"
                                        }
                                    }
                                },
                                {
                                    "title": "BACCARAT",
                                    "image": assetsMap.images.arenas.LiveArenas.live_arena_baccarat_png.toString(),
                                    "display": true,
                                    "seoPage": "/live-casino/baccarat/",
                                    "filter": "live-baccarat",
                                    "banners": {
                                        "promotionalBanner": {
                                            "templateID": "392012",
                                            "componentID": "517077"
                                        }
                                    }
                                },
                                {
                                    "title": "GAME_SHOWS",
                                    "image": assetsMap.images.arenas.LiveArenas.live_arena_dream_catcher_png.toString(),
                                    "display": true,
                                    "seoPage": "/live-casino/dream-catcher/",
                                    "filter": "live-game-shows",
                                    "banners": {
                                        "promotionalBanner": {
                                            "templateID": "392012",
                                            "componentID": "517084"
                                        }
                                    }
                                },
                                {
                                    "title": "SPEED_GAMES",
                                    "image": assetsMap.images.arenas.LiveArenas.live_arena_dream_catcher_png.toString(),
                                    "display": true,
                                    "seoPage": "/live-casino/speed-games/",
                                    "filter": "live-speed-games",
                                    "banners": {
                                        "promotionalBanner": {
                                            "templateID": "392012",
                                            "componentID": "517084"
                                        }
                                    }
                                }
                            ]
                        }
                    ]
                },
                "filters": [
                    "new",
                    "live-poker",
                    "live-blackjack",
                    "live-elite-lounge-or-exclusive",
                    "live-baccarat",
                    "live-roulette",
                    "live-game-shows",
                    "live-speed-games"
                ],
                "promotionalBanner": {
                    "displayRowPlace": {
                        "defaultValue": 4
                    },
                    "componentID": "407025",
                    "templateID": "392012"
                },
                "linkToOffer": {
                    "welcomeBonus": {
                        "componentID": "482082",
                        "templateID": "392012",
                        "display": {
                            "defaultValue": true,
                            "statements": [
                                {
                                    "rules": [
                                        {
                                            "id": "_IsCstatus",
                                            "operator": "equal",
                                            "value": true
                                        }
                                    ],
                                    "value": false
                                }
                            ]
                        }
                    }
                },
                "seoSection": {
                    "display": {
                        "defaultValue": true,
                        "statements": [
                            {
                                "condition": "OR",
                                "rules": [
                                    {
                                        "id": "isEmbeddedHybrid",
                                        "operator": "equal",
                                        "value": true
                                    },
                                    {
                                        "id": "IsAuthorized",
                                        "operator": "equal",
                                        "value": true
                                    }
                                ],
                                "value": false
                            }
                        ]
                    },
                    "componentID": "392031",
                    "templateID": "392012"
                },
                "orderListsByAI": false
            },
            "newLiveCasinoAB": {
                "topImage": {
                    "defaultValue": assetsMap.images.banners.new_evo_lobby_banner_pc_png.toString(),
                    "statements": [
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "mAndBelow",
                                    "operator": "equal",
                                    "value": true
                                }
                            ],
                            "value": assetsMap.images.banners.new_evo_lobby_banner_mobile_png
                        }
                    ]
                },
                "animatedTopImage": {
                    "url": {
                        "defaultValue": assetsMap.images.animated_banners.livecasino_arena_banner_pc_lottie.toString(),
                        "statements": [
                            {
                                "condition": "AND",
                                "rules": [
                                    {
                                        "id": "mAndBelow",
                                        "operator": "equal",
                                        "value": true
                                    }
                                ],
                                "value": assetsMap.images.animated_banners.livecasino_arena_banner_mobile_lottie.toString()
                            }
                        ]
                    }
                },
                "title": {
                    "defaultValue": "LIVE_CASINO",
                    "statements": []
                },
                "useAISortedList": false,
                "filters": [],
                "promotionalBanner": {
                    "displayListPlace": {
                        "defaultValue": 3
                    },
                    "componentID": "407025",
                    "templateID": "392012"
                },
                "linkToOffer": {
                    "welcomeBonus": {
                        "componentID": "482082",
                        "templateID": "392012",
                        "display": {
                            "defaultValue": true,
                            "statements": [
                                {
                                    "rules": [
                                        {
                                            "id": "_IsCstatus",
                                            "operator": "equal",
                                            "value": true
                                        }
                                    ],
                                    "value": false
                                }
                            ]
                        }
                    }
                },
                "seoSection": {
                    "display": {
                        "defaultValue": true,
                        "statements": [
                            {
                                "condition": "OR",
                                "rules": [
                                    {
                                        "id": "isEmbeddedHybrid",
                                        "operator": "equal",
                                        "value": true
                                    },
                                    {
                                        "id": "IsAuthorized",
                                        "operator": "equal",
                                        "value": true
                                    }
                                ],
                                "value": false
                            }
                        ]
                    },
                    "componentID": "392031",
                    "templateID": "392012"
                }
            },
            "roulette": {
                "topImage": {
                    "defaultValue": assetsMap.images.banners.roulette_arena_banner_pc_png.toString(),
                    "statements": [
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "mAndBelow",
                                    "operator": "equal",
                                    "value": true
                                }
                            ],
                            "value": assetsMap.images.banners.roulette_arena_banner_mobile_png.toString()
                        }
                    ]
                },
                "animatedTopImage": {
                    "url": {
                        "defaultValue": assetsMap.images.animated_banners.roulette_arena_banner_pc_lottie.toString(),
                        "statements": [
                            {
                                "condition": "AND",
                                "rules": [
                                    {
                                        "id": "mAndBelow",
                                        "operator": "equal",
                                        "value": true
                                    }
                                ],
                                "value": assetsMap.images.animated_banners.roulette_arena_banner_mobile_lottie.toString()
                            }
                        ]
                    }
                },
                "title": {
                    "defaultValue": "INFO_TITLE_ARENA_ROULETTE",
                    "statements": []
                },
                "filters": [],
                "infoSideBar": {
                    "infoImage": assetsMap.images.arenas.HomePage.roulette_arena_info_png.toString(),
                    "infoTitle": "INFO_TITLE_ARENA_ROULETTE",
                    "infoText": "INFO_TEXT_ARENA_ROULETTE"
                },
                "promotionalBanner": {
                    "display": false,
                    "componentID": "447899",
                    "templateID": "392012"
                },
                "linkToOffer": {
                    "welcomeBonus": {
                        "componentID": "482085",
                        "templateID": "392012",
                        "display": {
                            "defaultValue": true,
                            "statements": [
                                {
                                    "rules": [
                                        {
                                            "id": "_IsCstatus",
                                            "operator": "equal",
                                            "value": true
                                        }
                                    ],
                                    "value": false
                                }
                            ]
                        }
                    }
                },
                "seoSection": {
                    "display": {
                        "defaultValue": true,
                        "statements": [
                            {
                                "condition": "OR",
                                "rules": [
                                    {
                                        "id": "isEmbeddedHybrid",
                                        "operator": "equal",
                                        "value": true
                                    },
                                    {
                                        "id": "IsAuthorized",
                                        "operator": "equal",
                                        "value": true
                                    }
                                ],
                                "value": false
                            }
                        ]
                    },
                    "componentID": {
                        "defaultValue": "414150"
                    },
                    "templateID": {
                        "defaultValue": "392012"
                    }
                }
            },
            "blackjack": {
                "topImage": {
                    "defaultValue": assetsMap.images.banners.blackjack_arena_banner_pc_png.toString(),
                    "statements": [
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "mAndBelow",
                                    "operator": "equal",
                                    "value": true
                                }
                            ],
                            "value": assetsMap.images.banners.blackjack_arena_banner_mobile_png.toString()
                        }
                    ]
                },
                "animatedTopImage": {
                    "url": {
                        "defaultValue": assetsMap.images.animated_banners.blackjack_arena_banner_pc_lottie.toString(),
                        "statements": [
                            {
                                "condition": "AND",
                                "rules": [
                                    {
                                        "id": "mAndBelow",
                                        "operator": "equal",
                                        "value": true
                                    }
                                ],
                                "value": assetsMap.images.animated_banners.blackjack_arena_banner_mobile_lottie.toString()
                            }
                        ]
                    }
                },
                "title": {
                    "defaultValue": "INFO_TITLE_ARENA_BLACKJACK",
                    "statements": []
                },
                "filters": [],
                "infoSideBar": {
                    "infoImage": assetsMap.images.arenas.HomePage.blackjack_arena_info_png.toString(),
                    "infoTitle": "INFO_TITLE_ARENA_BLACKJACK",
                    "infoText": "INFO_TEXT_ARENA_BLACKJACK"
                },
                "promotionalBanner": {
                    "display": false,
                    "componentID": "447900",
                    "templateID": "392012"
                },
                "linkToOffer": {
                    "welcomeBonus": {
                        "componentID": "482062",
                        "templateID": "392012",
                        "display": {
                            "defaultValue": true,
                            "statements": [
                                {
                                    "rules": [
                                        {
                                            "id": "_IsCstatus",
                                            "operator": "equal",
                                            "value": true
                                        }
                                    ],
                                    "value": false
                                }
                            ]
                        }
                    }
                },
                "seoSection": {
                    "display": {
                        "defaultValue": true,
                        "statements": [
                            {
                                "condition": "OR",
                                "rules": [
                                    {
                                        "id": "isEmbeddedHybrid",
                                        "operator": "equal",
                                        "value": true
                                    },
                                    {
                                        "id": "IsAuthorized",
                                        "operator": "equal",
                                        "value": true
                                    }
                                ],
                                "value": false
                            }
                        ]
                    },
                    "componentID": {
                        "defaultValue": "414147"
                    },
                    "templateID": {
                        "defaultValue": "392012"
                    }
                }
            },
            "videoPoker": {
                "topImage": {
                    "defaultValue": assetsMap.images.banners.video_poker_arena_banner_pc_png.toString(),
                    "statements": [
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "mAndBelow",
                                    "operator": "equal",
                                    "value": true
                                }
                            ],
                            "value": assetsMap.images.banners.video_poker_arena_banner_mobile_png.toString()
                        }
                    ]
                },
                "animatedTopImage": {
                    "url": {
                        "defaultValue": assetsMap.images.animated_banners.videopoker_arena_banner_pc_lottie.toString(),
                        "statements": [
                            {
                                "condition": "AND",
                                "rules": [
                                    {
                                        "id": "mAndBelow",
                                        "operator": "equal",
                                        "value": true
                                    }
                                ],
                                "value": assetsMap.images.animated_banners.videopoker_arena_banner_mobile_lottie.toString()
                            }
                        ]
                    }
                },
                "title": {
                    "defaultValue": "INFO_TITLE_ARENA_VIDEO_POKER",
                    "statements": []
                },
                "filters": [],
                "infoSideBar": {
                    "infoImage": assetsMap.images.arenas.HomePage.video_poker_arena_info_png.toString(),
                    "infoTitle": "INFO_TITLE_ARENA_VIDEO_POKER",
                    "infoText": "INFO_TEXT_ARENA_VIDEO_POKER"
                },
                "promotionalBanner": {
                    "display": false,
                    "componentID": "447901",
                    "templateID": "392012"
                },
                "linkToOffer": {
                    "welcomeBonus": {
                        "componentID": "482094",
                        "templateID": "392012",
                        "display": {
                            "defaultValue": true,
                            "statements": [
                                {
                                    "rules": [
                                        {
                                            "id": "_IsCstatus",
                                            "operator": "equal",
                                            "value": true
                                        }
                                    ],
                                    "value": false
                                }
                            ]
                        }
                    }
                },
                "seoSection": {
                    "display": {
                        "defaultValue": true,
                        "statements": [
                            {
                                "condition": "OR",
                                "rules": [
                                    {
                                        "id": "isEmbeddedHybrid",
                                        "operator": "equal",
                                        "value": true
                                    },
                                    {
                                        "id": "IsAuthorized",
                                        "operator": "equal",
                                        "value": true
                                    }
                                ],
                                "value": false
                            }
                        ]
                    },
                    "componentID": {
                        "defaultValue": "414153"
                    },
                    "templateID": {
                        "defaultValue": "392012"
                    }
                }
            },
            "scratchCards": {
                "topImage": {
                    "defaultValue": assetsMap.images.banners.scratch_card_arena_banner_pc_png.toString(),
                    "statements": [
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "mAndBelow",
                                    "operator": "equal",
                                    "value": true
                                }
                            ],
                            "value": assetsMap.images.banners.scratch_card_arena_banner_mobile_png.toString()
                        }
                    ]
                },
                "animatedTopImage": {
                    "url": {
                        "defaultValue": assetsMap.images.animated_banners.scratchcards_arena_banner_pc_lottie.toString(),
                        "statements": [
                            {
                                "condition": "AND",
                                "rules": [
                                    {
                                        "id": "mAndBelow",
                                        "operator": "equal",
                                        "value": true
                                    }
                                ],
                                "value": assetsMap.images.animated_banners.scratchcards_arena_banner_mobile_lottie.toString()
                            }
                        ]
                    }
                },
                "title": {
                    "defaultValue": "INFO_TITLE_ARENA_SCRATCH_CARDS",
                    "statements": []
                },
                "filters": [],
                "infoSideBar": {
                    "infoImage": assetsMap.images.arenas.HomePage.scratch_cards_arena_info_png.toString(),
                    "infoTitle": "INFO_TITLE_ARENA_SCRATCH_CARDS",
                    "infoText": "INFO_TEXT_ARENA_SCRATCH_CARDS"
                },
                "promotionalBanner": {
                    "display": false,
                    "componentID": "447902",
                    "templateID": "392012"
                },
                "linkToOffer": {
                    "welcomeBonus": {
                        "componentID": "482088",
                        "templateID": "392012",
                        "display": {
                            "defaultValue": true,
                            "statements": [
                                {
                                    "rules": [
                                        {
                                            "id": "_IsCstatus",
                                            "operator": "equal",
                                            "value": true
                                        }
                                    ],
                                    "value": false
                                }
                            ]
                        }
                    }
                },
                "seoSection": {
                    "display": {
                        "defaultValue": true,
                        "statements": [
                            {
                                "condition": "OR",
                                "rules": [
                                    {
                                        "id": "isEmbeddedHybrid",
                                        "operator": "equal",
                                        "value": true
                                    },
                                    {
                                        "id": "IsAuthorized",
                                        "operator": "equal",
                                        "value": true
                                    }
                                ],
                                "value": false
                            }
                        ]
                    },
                    "componentID": {
                        "defaultValue": "414167"
                    },
                    "templateID": {
                        "defaultValue": "392012"
                    }
                }
            },
            "virtualSport": {
                "topImage": {
                    "defaultValue": assetsMap.images.banners.virtual_sports_arena_banner_pc_png.toString(),
                    "statements": [
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "mAndBelow",
                                    "operator": "equal",
                                    "value": true
                                }
                            ],
                            "value": assetsMap.images.banners.virtual_sports_arena_banner_mobile_png.toString()
                        }
                    ]
                },
                "title": "VIRTUAL_SPORTS",
                "filters": [],
                "infoSideBar": {
                    "infoImage": assetsMap.images.arenas.HomePage.visual_sport_arena_info_png.toString(),
                    "infoTitle": "INFO_TITLE_ARENA_VIRTUAL_SPORTS",
                    "infoText": "INFO_TEXT_ARENA_VIRTUAL_SPORTS"
                },
                "promotionalBanner": {
                    "display": false,
                    "componentID": "",
                    "templateID": ""
                },
                "seoSection": {
                    "display": false,
                    "componentID": "",
                    "templateID": ""
                }
            },
            "gameShows": {},
            "newGames": {
                "topImage": {
                    "defaultValue": assetsMap.images.banners.new_games_arena_banner_pc_png.toString(),
                    "statements": [
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "mAndBelow",
                                    "operator": "equal",
                                    "value": true
                                }
                            ],
                            "value": assetsMap.images.banners.new_games_arena_banner_mobile_png.toString()
                        }
                    ]
                },
                "animatedTopImage": {
                    "url": {
                        "defaultValue": assetsMap.images.animated_banners.newgames_arena_banner_pc_lottie.toString(),
                        "statements": [
                            {
                                "condition": "AND",
                                "rules": [
                                    {
                                        "id": "mAndBelow",
                                        "operator": "equal",
                                        "value": true
                                    }
                                ],
                                "value": assetsMap.images.animated_banners.newgames_arena_banner_pc_lottie.toString()
                            }
                        ]
                    }
                },
                "title": {
                    "defaultValue": "INFO_TITLE_ARENA_NEW_GAMES",
                    "statements": []
                },
                "filters": [],
                "infoSideBar": {
                    "infoImage": assetsMap.images.arenas.HomePage.new_games_arena_info_png.toString(),
                    "infoTitle": "INFO_TITLE_ARENA_NEW_GAMES",
                    "infoText": "INFO_TEXT_ARENA_NEW_GAMES"
                },
                "promotionalBanner": {
                    "display": false,
                    "componentID": "524212",
                    "templateID": "392012"
                },
                "seoSection": {
                    "display": {
                        "defaultValue": true,
                        "statements": [
                            {
                                "condition": "OR",
                                "rules": [
                                    {
                                        "id": "isEmbeddedHybrid",
                                        "operator": "equal",
                                        "value": true
                                    },
                                    {
                                        "id": "IsAuthorized",
                                        "operator": "equal",
                                        "value": true
                                    }
                                ],
                                "value": false
                            }
                        ]
                    },
                    "componentID": "524218",
                    "templateID": "392012"
                },
                "linkToOffer": {
                    "welcomeBonus": {
                        "componentID": "548144",
                        "templateID": "392012",
                        "display": {
                            "defaultValue": true,
                            "statements": [
                                {
                                    "rules": [
                                        {
                                            "id": "_IsCstatus",
                                            "operator": "equal",
                                            "value": true
                                        }
                                    ],
                                    "value": false
                                }
                            ]
                        }
                    }
                }
            }
        },
        "homePage": {
            "topBanner": {
                "templateID": "392012",
                "miniTopBannerComponentID": "531497"
            },
            "headerArenasOrder": [
                "liveCasinoMenuItem",
                "slotsMenuItem",
                "newGamesMenuItem",
                "jackpotsMenuItem",
                "exclusive888arenaMenuItem",
                "casinoMenuItem"
            ],
            "promotionalBanner": {
                "displayPlace": {
                    "defaultValue": 5
                },
                "componentID": {
                    "defaultValue": "548235"
                },
                "templateID": {
                    "defaultValue": "392012"
                }
            },
            "videoSlidesFilter": {
                "position": 3,
                "filterIds": ["has-jackpot", "theme_seasonal"],
            },
            "seoSection": {
                "display": {
                    "defaultValue": true,
                    "statements": [
                        {
                            "condition": "OR",
                            "rules": [
                                {
                                    "id": "isEmbeddedHybrid",
                                    "operator": "equal",
                                    "value": true
                                },
                                {
                                    "id": "IsAuthorized",
                                    "operator": "equal",
                                    "value": true
                                }
                            ],
                            "value": false
                        }
                    ]
                },
                "componentID": {
                    "defaultValue": "392015"
                },
                "templateID": {
                    "defaultValue": "392012"
                }
            },
            "linkToOffer": {
                "welcomeBonus": {
                    "componentID": "521460",
                    "templateID": "392012",
                    "display": {
                        "defaultValue": true,
                        "statements": [
                            {
                                "rules": [
                                    {
                                        "id": "_IsCstatus",
                                        "operator": "equal",
                                        "value": true
                                    }
                                ],
                                "value": false
                            }
                        ]
                    }
                }
            }
        },
        "historyPage": {
            "topImage": {
                "defaultValue": assetsMap.images.history_bg_title_png.toString(),
                "statements": []
            },
            "title": {
                "defaultValue": "GAMING_HISTORY",
                "statements": []
            }
        },
        "generalSettings": {
            "brandName": "888Casino",
            "showBreadcrumbs": true,
            "googleOptimize": {
                "isEnabled": false
            },
            "logoAltOverride": "888 Online Casino",
            "logoURL": {
                "defaultValue": assetsMap.images._888casinologo_pc_svg.toString(),
                "statements": [
                    {
                        "condition": "AND",
                        "rules": [
                            {
                                "id": "statusGroupId",
                                "operator": "any_of",
                                "value": [0, 4]
                            },
                            {
                                "id": "deviceType",
                                "operator": "equal",
                                "value": "mobile"
                            }
                        ],
                        "value": assetsMap.images._888casinologo_mobile_svg.toString()
                    },
                    {
                        "condition": "AND",
                        "rules": [
                            {
                                "id": "statusGroupId",
                                "operator": "equal",
                                "value": 1
                            },
                            {
                                "id": "deviceType",
                                "operator": "equal",
                                "value": "pc"
                            }
                        ],
                        "value": assetsMap.images.logos.reg_vip.vip_regular_logo_pc_svg.toString()
                    },
                    {
                        "condition": "AND",
                        "rules": [
                            {
                                "id": "statusGroupId",
                                "operator": "equal",
                                "value": 1
                            },
                            {
                                "id": "deviceType",
                                "operator": "equal",
                                "value": "mobile"
                            }
                        ],
                        "value": assetsMap.images.logos.reg_vip.vip_regular_logo_mobile_svg.toString()
                    },
                    {
                        "condition": "AND",
                        "rules": [
                            {
                                "id": "statusGroupId",
                                "operator": "equal",
                                "value": 2
                            },
                            {
                                "id": "deviceType",
                                "operator": "equal",
                                "value": "pc"
                            }
                        ],
                        "value": assetsMap.images.logos.gold_vip.vip_gold_logo_pc_svg.toString()
                    },
                    {
                        "condition": "AND",
                        "rules": [
                            {
                                "id": "statusGroupId",
                                "operator": "equal",
                                "value": 2
                            },
                            {
                                "id": "deviceType",
                                "operator": "equal",
                                "value": "mobile"
                            }
                        ],
                        "value": assetsMap.images.logos.gold_vip.vip_gold_logo_mobile_svg.toString()
                    },
                    {
                        "condition": "AND",
                        "rules": [
                            {
                                "id": "statusGroupId",
                                "operator": "equal",
                                "value": 3
                            },
                            {
                                "id": "deviceType",
                                "operator": "equal",
                                "value": "pc"
                            }
                        ],
                        "value": assetsMap.images.logos.diamond_vip.vip_diamond_logo_pc_svg.toString()
                    },
                    {
                        "condition": "AND",
                        "rules": [
                            {
                                "id": "statusGroupId",
                                "operator": "equal",
                                "value": 3
                            },
                            {
                                "id": "deviceType",
                                "operator": "equal",
                                "value": "mobile"
                            }
                        ],
                        "value": assetsMap.images.logos.diamond_vip.vip_diamond_logo_mobile_svg.toString()
                    },
                    {
                        "condition": "AND",
                        "rules": [
                            {
                                "id": "statusGroupId",
                                "operator": "equal",
                                "value": 5
                            },
                            {
                                "id": "deviceType",
                                "operator": "equal",
                                "value": "pc"
                            }
                        ],
                        "value": assetsMap.images.logos.platinum_vip.vip_platinum_logo_pc_svg.toString()
                    },
                    {
                        "condition": "AND",
                        "rules": [
                            {
                                "id": "statusGroupId",
                                "operator": "equal",
                                "value": 5
                            },
                            {
                                "id": "deviceType",
                                "operator": "equal",
                                "value": "mobile"
                            }
                        ],
                        "value": assetsMap.images.logos.platinum_vip.vip_platinum_logo_mobile_svg.toString()
                    }
                ]
            },
            "avatarUrl": {
                "drawer": {
                    "defaultValue": {
                        "regular": assetsMap.images.avatars.reg.pre_login_reg_png.toString(),
                        "hover": assetsMap.images.avatars.reg.pre_login_reg_png.toString(),
                        "pressed": assetsMap.images.avatars.reg.pre_login_reg_png.toString()
                    },
                    "statements": [
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "statusGroupId",
                                    "operator": "equal",
                                    "value": 0
                                }
                            ],
                            "value": {
                                "regular": assetsMap.images.user_menu_box_icon_png.toString(),
                                "hover": assetsMap.images.user_menu_box_icon_png.toString(),
                                "pressed": assetsMap.images.user_menu_box_icon_png.toString()
                            }
                        },
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "statusGroupId",
                                    "operator": "equal",
                                    "value": 1
                                }
                            ],
                            "value": {
                                "regular": assetsMap.images.avatars.reg_vip.my_account_vip_reg_png.toString(),
                                "hover": assetsMap.images.avatars.reg_vip.my_account_vip_reg_png.toString(),
                                "pressed": assetsMap.images.avatars.reg_vip.my_account_vip_reg_png.toString()
                            }
                        },
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "statusGroupId",
                                    "operator": "equal",
                                    "value": 2
                                }
                            ],
                            "value": {
                                "regular": assetsMap.images.avatars.gold_vip.my_account_gold_vip_png.toString(),
                                "hover": assetsMap.images.avatars.gold_vip.my_account_gold_vip_png.toString(),
                                "pressed": assetsMap.images.avatars.gold_vip.my_account_gold_vip_png.toString()
                            }
                        },
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "statusGroupId",
                                    "operator": "equal",
                                    "value": 3
                                }
                            ],
                            "value": {
                                "regular": assetsMap.images.avatars.diamond_vip.my_account_diamond_vip_png.toString(),
                                "hover": assetsMap.images.avatars.diamond_vip.my_account_diamond_vip_png.toString(),
                                "pressed": assetsMap.images.avatars.diamond_vip.my_account_diamond_vip_png.toString()
                            }
                        },
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "statusGroupId",
                                    "operator": "equal",
                                    "value": 5
                                }
                            ],
                            "value": {
                                "regular": assetsMap.images.avatars.platinum_vip.my_account_vip_platinum_png.toString(),
                                "hover": assetsMap.images.avatars.platinum_vip.my_account_vip_platinum_png.toString(),
                                "pressed": assetsMap.images.avatars.platinum_vip.my_account_vip_platinum_png.toString()
                            }
                        }
                    ]
                },
                "sideMenu": {
                    "defaultValue": {
                        "regular": assetsMap.images.avatars.reg.pre_login_reg_svg.toString(),
                        "hover": assetsMap.images.avatars.reg.pre_login_hover_svg.toString(),
                        "pressed": assetsMap.images.avatars.reg.pre_login_pressed_svg.toString(),
                    },
                    "statements": [
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "IsAuthorized",
                                    "operator": "equal",
                                    "value": false
                                },
                                {
                                    "id": "statusGroupId",
                                    "operator": "equal",
                                    "value": 1
                                }
                            ],
                            "value": {
                                "regular": assetsMap.images.avatars.reg_vip.pre_login_reg_vip_avatar_icon_regular_svg.toString(),
                                "hover": assetsMap.images.avatars.reg_vip.pre_login_reg_vip_avatar_icon_hover_svg.toString(),
                                "pressed": assetsMap.images.avatars.reg_vip.pre_login_reg_vip_avatar_icon_pressed_svg.toString()
                            }
                        },
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "IsAuthorized",
                                    "operator": "equal",
                                    "value": false
                                },
                                {
                                    "id": "statusGroupId",
                                    "operator": "equal",
                                    "value": 2
                                }
                            ],
                            "value": {
                                "regular": assetsMap.images.avatars.gold_vip.pre_login_gold_vip_avatar_regular_svg.toString(),
                                "hover": assetsMap.images.avatars.gold_vip.pre_login_gold_vip_avatar_hover_svg.toString(),
                                "pressed": assetsMap.images.avatars.gold_vip.pre_login_gold_vip_avatar_pressed_svg.toString()
                            }
                        },
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "IsAuthorized",
                                    "operator": "equal",
                                    "value": false
                                },
                                {
                                    "id": "statusGroupId",
                                    "operator": "equal",
                                    "value": 3
                                }
                            ],
                            "value": {
                                "regular": assetsMap.images.avatars.diamond_vip.pre_login_diamond_vip_avatar_regular_svg.toString(),
                                "hover": assetsMap.images.avatars.diamond_vip.pre_login_diamond_vip_avatar_hover_svg.toString(),
                                "pressed": assetsMap.images.avatars.diamond_vip.pre_login_diamond_vip_avatar_pressed_svg.toString()
                            }
                        },
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "IsAuthorized",
                                    "operator": "equal",
                                    "value": false
                                },
                                {
                                    "id": "statusGroupId",
                                    "operator": "equal",
                                    "value": 5
                                }
                            ],
                            "value": {
                                "regular": assetsMap.images.avatars.platinum_vip.pre_login_vip_platinum_avatar_regular_svg.toString(),
                                "hover": assetsMap.images.avatars.platinum_vip.pre_login_vip_platinum_avatar_hover_svg.toString(),
                                "pressed": assetsMap.images.avatars.platinum_vip.pre_login_vip_platinum_avatar_pressed_svg.toString()
                            }
                        },
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "statusGroupId",
                                    "operator": "equal",
                                    "value": 0
                                },
                                {
                                    "id": "IsAuthorized",
                                    "operator": "equal",
                                    "value": true
                                }
                            ],
                            "value": {
                                "regular": assetsMap.images.avatars.reg.post_login_reg_svg.toString(),
                                "hover": assetsMap.images.avatars.reg.post_login_hover_svg.toString(),
                                "pressed": assetsMap.images.avatars.reg.post_login_pressed_svg.toString(),
                            }
                        },
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "statusGroupId",
                                    "operator": "equal",
                                    "value": 1
                                },
                                {
                                    "id": "IsAuthorized",
                                    "operator": "equal",
                                    "value": true
                                }
                            ],
                            "value": {
                                "regular": assetsMap.images.avatars.reg_vip.post_login_reg_vip_avatar_regular_svg.toString(),
                                "hover": assetsMap.images.avatars.reg_vip.post_login_reg_vip_avatar_hover_svg.toString(),
                                "pressed": assetsMap.images.avatars.reg_vip.post_login_reg_vip_avatar_pressed_svg.toString()
                            }
                        },
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "statusGroupId",
                                    "operator": "equal",
                                    "value": 2
                                },
                                {
                                    "id": "IsAuthorized",
                                    "operator": "equal",
                                    "value": true
                                }
                            ],
                            "value": {
                                "regular": assetsMap.images.avatars.gold_vip.post_login_gold_vip_avatar_regular_svg.toString(),
                                "hover": assetsMap.images.avatars.gold_vip.post_login_gold_vip_avatar_hover_svg.toString(),
                                "pressed": assetsMap.images.avatars.gold_vip.post_login_gold_vip_avatar_pressed_svg.toString()
                            }
                        },
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "statusGroupId",
                                    "operator": "equal",
                                    "value": 3
                                },
                                {
                                    "id": "IsAuthorized",
                                    "operator": "equal",
                                    "value": true
                                }
                            ],
                            "value": {
                                "regular": assetsMap.images.avatars.diamond_vip.post_login_diamond_vip_avatar_regular_svg.toString(),
                                "hover": assetsMap.images.avatars.diamond_vip.post_login_diamond_vip_avatar_hover_svg.toString(),
                                "pressed": assetsMap.images.avatars.diamond_vip.post_login_diamond_vip_avatar_pressed_svg.toString()
                            }
                        },
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "statusGroupId",
                                    "operator": "equal",
                                    "value": 5
                                },
                                {
                                    "id": "IsAuthorized",
                                    "operator": "equal",
                                    "value": true
                                }
                            ],
                            "value": {
                                "regular": assetsMap.images.avatars.platinum_vip.post_login_vip_platinum_avatar_regular_svg.toString(),
                                "hover": assetsMap.images.avatars.platinum_vip.post_login_vip_platinum_avatar_hover_svg.toString(),
                                "pressed": assetsMap.images.avatars.platinum_vip.post_login_vip_platinum_avatar_pressed_svg.toString()
                            }
                        }
                    ]
                }
            },
            "gamesSettings": {
                "homePageArenaDefaultPlaceHolder":  assetsMap.images.arenas.HomePage.default_header_arena_icon_png.toString(),
                "liveArenaDefaultPlaceHolder": assetsMap.images.arenas.LiveArenas.default_live_arena_png.toString()
            },
            "gamesPreviewConfig": {
                "disabledFeatures": [
                    "minBet",
                    "maxBet"
                ]
            },
            "filters": {
                "advancedFilters": {
                    "preferredVendorFilters": [
                        "vendor_888",
                        "vendor_pragmatic",
                        "vendor_gamesglobal",
                        "vendor_playtech",
                        "vendor_blueprint",
                        "vendor_evolution",
                        "vendor_playngo",
                        "vendor_inspired",
                        "vendor_redtiger",
                        "vendor_lnw",
                        "vendor_yggdrasil",
                        "vendor_realistic",
                        "vendor_1x2",
                        "vendor_hacksaw",
                        "vendor_spinomenal",
                        "vendor_stake_logic",
                        "vendor_redrake",
                        "vendor_netent",
                        "vendor_gamingrealms",
                        "vendor_rubyplay"
                    ],
                    "preferredThemeFilters": [
                        "theme_fish",
                        "theme_egyptian",
                        "theme_wildlife",
                        "theme_greek_mythology",
                        "theme_irish",
                        "theme_classic_style",
                        "theme_fantasy_and_folklore",
                        "theme_movies_and_music",
                        "theme_money_and_leisure",
                        "theme_adventure",
                        "theme_arabic",
                        "theme_diamonds_and_gems",
                        "theme_comics_and_cartoons",
                        "theme_fruit_and_candy",
                        "theme_asian",
                        "theme_seasonal"
                    ]
                }
            }
        },
        "wheelOfFortune": {
            "display": {
                "defaultValue": false,
                "statements": [
                    {
                        "condition": "AND",
                        "rules": [
                            {
                                "id": "IsAuthorized",
                                "operator": "equal",
                                "value": true
                            }
                        ],
                        "value": true
                    }
                ]
            },
            "componentID": "528515",
            "templateID": "392012"
        },
        "registrationOffer": {
            "display": {
                "defaultValue": false,
                "statements": [
                    {
                        "condition": "AND",
                        "rules": [
                            {
                                "id": "IsAuthorized",
                                "operator": "equal",
                                "value": false
                            },
                            {
                                "id": "_IsUk",
                                "operator": "equal",
                                "value": "false"
                            }
                        ],
                        "value": true
                    }
                ]
            },
            "componentID": "543317",
            "templateID": "392012"
        },
        "onboardingTour": {
            "featureToggle": {
                "defaultValue": FeatureToggleStatusEnum.Enabled,
                "statements": [
                    {
                        "condition": "OR",
                        "rules": [
                            {
                                "id": "_IsCIS",
                                "operator": "equal",
                                "value": true
                            },
                            {
                                "id": "_IsCIP",
                                "operator": "equal",
                                "value": true
                            }
                        ],
                        "value": FeatureToggleStatusEnum.Disabled
                    }
                ]
            }
        },
        "SDK": {
            "WebPush": {
                "prodSettings": {
                    "defaultIcon": "https://c00120-dl.urbanairship.com/binary/public/IuA6rjx3SPSMprXE4QLmRg/dce2de43-d01d-4101-9dc8-8e537fb9e2b7",
                    "defaultTitle": "888Casino",
                    "defaultActionURL": "https://www.888casino.com",
                    "appKey": "IuA6rjx3SPSMprXE4QLmRg",
                    "token": "MTpJdUE2cmp4M1NQU01wclhFNFFMbVJnOmdXS2V0bXV5U3BET2hqWDVOMUhBS2hJUmxFZ0NmTk5NYjFvNXd5WW0zYWM",
                    "vapidPublicKey": "BHCZt97nOVp8n6rSEO1wjhk4fPRikwrpsZcStPfhajaxjebHPdUZINgAZTLoN5jZjWqFsT8-h8u4GDmW0Qg-BfA="
                }
            },
            "Skin": {
                "androidDefaultHybridSerial": "1404746"
            },
            "JackpotToasters": {
                "toasterPerGame": [
                    {
                        "gameTypes": [
                            130043
                        ],
                        "thresholds": [
                            {
                                "threshold": 600000000,
                                "toasterName": "PROGRESSIVE_JACKPOT_ALERT",
                                "contentText": "jackpot_amount_threshold_text_template7",
                                "titleText": "progressive_jackpot_threshold_toaster_title"
                            },
                            {
                                "threshold": 550000000,
                                "toasterName": "PROGRESSIVE_JACKPOT_ALERT",
                                "contentText": "jackpot_amount_threshold_text_template7",
                                "titleText": "progressive_jackpot_threshold_toaster_title"
                            },
                            {
                                "threshold": 500000000,
                                "toasterName": "PROGRESSIVE_JACKPOT_ALERT",
                                "contentText": "jackpot_amount_threshold_text_template7",
                                "titleText": "progressive_jackpot_threshold_toaster_title"
                            },
                            {
                                "threshold": 450000000,
                                "toasterName": "PROGRESSIVE_JACKPOT_ALERT",
                                "contentText": "jackpot_amount_threshold_text_template7",
                                "titleText": "progressive_jackpot_threshold_toaster_title"
                            },
                            {
                                "threshold": 400000000,
                                "toasterName": "PROGRESSIVE_JACKPOT_ALERT",
                                "contentText": "jackpot_amount_threshold_text_template7",
                                "titleText": "progressive_jackpot_threshold_toaster_title"
                            },
                            {
                                "threshold": 350000000,
                                "toasterName": "PROGRESSIVE_JACKPOT_ALERT",
                                "contentText": "jackpot_amount_threshold_text_template7",
                                "titleText": "progressive_jackpot_threshold_toaster_title"
                            },
                            {
                                "threshold": 300000000,
                                "toasterName": "PROGRESSIVE_JACKPOT_ALERT",
                                "contentText": "jackpot_amount_threshold_text_template5",
                                "titleText": "progressive_jackpot_threshold_toaster_title"
                            },
                            {
                                "threshold": 250000000,
                                "toasterName": "PROGRESSIVE_JACKPOT_ALERT",
                                "contentText": "jackpot_amount_threshold_text_template6",
                                "titleText": "progressive_jackpot_threshold_toaster_title"
                            },
                            {
                                "threshold": 200000000,
                                "toasterName": "PROGRESSIVE_JACKPOT_ALERT",
                                "contentText": "jackpot_amount_threshold_text_template3",
                                "titleText": "progressive_jackpot_threshold_toaster_title"
                            },
                            {
                                "threshold": 150000000,
                                "toasterName": "PROGRESSIVE_JACKPOT_ALERT",
                                "contentText": "jackpot_amount_threshold_text_template2",
                                "titleText": "progressive_jackpot_threshold_toaster_title"
                            },
                            {
                                "threshold": 100000000,
                                "toasterName": "PROGRESSIVE_JACKPOT_ALERT",
                                "contentText": "jackpot_amount_threshold_text_template1",
                                "titleText": "progressive_jackpot_threshold_toaster_title"
                            }
                        ],
                        "showGameIcon": true
                    },
                    {
                        "gameTypes": [
                            130166
                        ],
                        "thresholds": [
                            {
                                "threshold": 300000000,
                                "toasterName": "PROGRESSIVE_JACKPOT_ALERT",
                                "contentText": "jackpot_amount_threshold_text_template7",
                                "titleText": "progressive_jackpot_threshold_toaster_title"
                            },
                            {
                                "threshold": 250000000,
                                "toasterName": "PROGRESSIVE_JACKPOT_ALERT",
                                "contentText": "jackpot_amount_threshold_text_template7",
                                "titleText": "progressive_jackpot_threshold_toaster_title"
                            },
                            {
                                "threshold": 200000000,
                                "toasterName": "PROGRESSIVE_JACKPOT_ALERT",
                                "contentText": "jackpot_amount_threshold_text_template6",
                                "titleText": "progressive_jackpot_threshold_toaster_title"
                            },
                            {
                                "threshold": 150000000,
                                "toasterName": "PROGRESSIVE_JACKPOT_ALERT",
                                "contentText": "jackpot_amount_threshold_text_template3",
                                "titleText": "progressive_jackpot_threshold_toaster_title"
                            },
                            {
                                "threshold": 100000000,
                                "toasterName": "PROGRESSIVE_JACKPOT_ALERT",
                                "contentText": "jackpot_amount_threshold_text_template2",
                                "titleText": "progressive_jackpot_threshold_toaster_title"
                            },
                            {
                                "threshold": 50000000,
                                "toasterName": "PROGRESSIVE_JACKPOT_ALERT",
                                "contentText": "jackpot_amount_threshold_text_template1",
                                "titleText": "progressive_jackpot_threshold_toaster_title"
                            }
                        ],
                        "showGameIcon": true
                    },
                    {
                        "gameTypes": [
                            2310333,
                            2310334
                        ],
                        "thresholds": [
                            {
                                "threshold": 500000000,
                                "toasterName": "PROGRESSIVE_JACKPOT_ALERT",
                                "contentText": "jackpot_amount_threshold_text_template7",
                                "titleText": "progressive_jackpot_threshold_toaster_title"
                            },
                            {
                                "threshold": 450000000,
                                "toasterName": "PROGRESSIVE_JACKPOT_ALERT",
                                "contentText": "jackpot_amount_threshold_text_template7",
                                "titleText": "progressive_jackpot_threshold_toaster_title"
                            },
                            {
                                "threshold": 400000000,
                                "toasterName": "PROGRESSIVE_JACKPOT_ALERT",
                                "contentText": "jackpot_amount_threshold_text_template7",
                                "titleText": "progressive_jackpot_threshold_toaster_title"
                            },
                            {
                                "threshold": 350000000,
                                "toasterName": "PROGRESSIVE_JACKPOT_ALERT",
                                "contentText": "jackpot_amount_threshold_text_template7",
                                "titleText": "progressive_jackpot_threshold_toaster_title"
                            },
                            {
                                "threshold": 300000000,
                                "toasterName": "PROGRESSIVE_JACKPOT_ALERT",
                                "contentText": "jackpot_amount_threshold_text_template5",
                                "titleText": "progressive_jackpot_threshold_toaster_title"
                            },
                            {
                                "threshold": 250000000,
                                "toasterName": "PROGRESSIVE_JACKPOT_ALERT",
                                "contentText": "jackpot_amount_threshold_text_template6",
                                "titleText": "progressive_jackpot_threshold_toaster_title"
                            },
                            {
                                "threshold": 200000000,
                                "toasterName": "PROGRESSIVE_JACKPOT_ALERT",
                                "contentText": "jackpot_amount_threshold_text_template3",
                                "titleText": "progressive_jackpot_threshold_toaster_title"
                            },
                            {
                                "threshold": 150000000,
                                "toasterName": "PROGRESSIVE_JACKPOT_ALERT",
                                "contentText": "jackpot_amount_threshold_text_template2",
                                "titleText": "progressive_jackpot_threshold_toaster_title"
                            },
                            {
                                "threshold": 100000000,
                                "toasterName": "PROGRESSIVE_JACKPOT_ALERT",
                                "contentText": "jackpot_amount_threshold_text_template1",
                                "titleText": "progressive_jackpot_threshold_toaster_title"
                            }
                        ],
                        "showGameIcon": true
                    }
                ]
            },
            "AppLauncher": {
                "apps": {
                    "CR_CHAT": {
                        "enabled": true
                    }
                }
            }
        }
    }
}